"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.utils = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _ = _interopRequireWildcard(require("lodash"));
var _urijs = _interopRequireDefault(require("urijs"));
var _httpClient = require("@wix/http-client");
var _photographyClientLib = require("@wix/photography-client-lib");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var httpClient = new _httpClient.HttpClient();
var Utils = /*#__PURE__*/function (_RenderUtils) {
  /* @ngInject */
  function Utils() {
    var _this;
    _this = _RenderUtils.call(this) || this;
    (0, _defineProperty2["default"])(_this, "data", {
      set: function set(key, value) {
        var dataKey = _this.dataPublicKey(key);
        return new Promise(function (resolve, reject) {
          return _photographyClientLib.Wix.Data.Public.set(dataKey, value, {
            scope: 'APP'
          }, function (data) {
            return resolve(data.dataKey);
          }, function (err) {
            return reject(err);
          });
        });
      },
      get: function get(key) {
        var dataKey = _this.dataPublicKey(key);
        return new Promise(function (resolve, reject) {
          return _photographyClientLib.Wix.Data.Public.get(dataKey, {
            scope: 'APP'
          }, function (data) {
            return resolve(data.dataKey);
          }, function (err) {
            return reject(err);
          });
        });
      }
    });
    (0, _defineProperty2["default"])(_this, "gallerySettings", function () {
      var baseUrl = _photographyClientLib.window.location.protocol + '//progallery.wixapps.net/_api/pro-gallery-editor-webapp/v1/gallery/';
      var getGallerySettingsApi = function getGallerySettingsApi() {
        return "" + baseUrl + _photographyClientLib.window.galleryId + "?instance=" + _photographyClientLib.window.instance + "&isStore=" + _this.isStoreGallery();
      };
      return {
        get: function get(key) {
          return httpClient.get(getGallerySettingsApi(), {
            withCredentials: true,
            xsrfCookieName: null
          }).then(function (_ref) {
            var data = _ref.data;
            return data.settings ? key ? data.settings[key] : data.settings : null;
          });
        },
        set: function set(key, value) {
          var _this$gallerySettings;
          return _this.gallerySettings.setMultiple((_this$gallerySettings = {}, _this$gallerySettings[key] = value, _this$gallerySettings));
        },
        setMultiple: function setMultiple(keysValuesObject) {
          return _this.gallerySettings.get().then(function (data) {
            data = data || {};
            var settings = Object.assign(data, keysValuesObject);
            return httpClient.put(getGallerySettingsApi(), {
              settings: settings
            }, {
              withCredentials: true,
              xsrfCookieName: null
            }).then(function () {
              return _this.setExternalId();
            });
          });
        },
        getAppSettings: function () {
          var _getAppSettings = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(key) {
            var _value, value;
            return _regenerator["default"].wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  if (!_photographyClientLib.experimentsWrapper.getExperimentBoolean('specs.pro-gallery.appSettings')) {
                    _context.next = 12;
                    break;
                  }
                  _context.prev = 1;
                  _context.next = 4;
                  return _this.appSettings.get(_photographyClientLib.Consts.dataSavedState.SAVED, key);
                case 4:
                  _value = _context.sent;
                  if (!(_value !== undefined)) {
                    _context.next = 7;
                    break;
                  }
                  return _context.abrupt("return", Promise.resolve(_value));
                case 7:
                  _context.next = 12;
                  break;
                case 9:
                  _context.prev = 9;
                  _context.t0 = _context["catch"](1);
                  console.error('Failed to get ' + key + ' from app settings: ' + _context.t0);
                case 12:
                  _context.next = 14;
                  return _this.gallerySettings.get(key);
                case 14:
                  value = _context.sent;
                  try {
                    if (_photographyClientLib.experimentsWrapper.getExperimentBoolean('specs.pro-gallery.appSettings')) {
                      _this.appSettings.set(key, value);
                    }
                  } catch (error) {
                    console.error('Failed to set ' + key + ' to app settings: ' + error);
                  }
                  return _context.abrupt("return", Promise.resolve(value));
                case 17:
                case "end":
                  return _context.stop();
              }
            }, _callee, null, [[1, 9]]);
          }));
          function getAppSettings(_x) {
            return _getAppSettings.apply(this, arguments);
          }
          return getAppSettings;
        }()
      };
    }());
    _this._cache = {};
    _this._hash2int = {};
    _this._refs = {};
    _this._params = {};
    _this.CONST_ADI_SUPPORT_WIDGET_CODE = '63ff21be-9556-4f52-9ac9-4d441bd3dae4';
    _this.CONST_EDITOR_WIDGET_CODE = 'cb6480f3-768b-4737-ab8f-10fe2e4fa2ab';
    _this.openManagePhotos = _this.openManagePhotos.bind(_this);
    try {
      document.domain = 'wixapps.net';
    } catch (e) {
      // console.warn('failed to set domain');
    }
    _this.isAccessibilityEnabled(); // populate the cache with the sdk response
    _this.appSettings = new _photographyClientLib.AppSettings();
    return _this;
  }

  // isStoreGallery() {
  //   return true
  // }
  (0, _inheritsLoose2["default"])(Utils, _RenderUtils);
  var _proto = Utils.prototype;
  _proto.addItemHashParam = function addItemHashParam(baseUrl, photoId) {
    var curParamsIndex = baseUrl.indexOf('pro-gallery-item=');
    if (curParamsIndex > 0) {
      baseUrl = baseUrl.substr(0, baseUrl.indexOf('pro-gallery-item=') - 1);
    }
    var prefix = '';
    var hashPart = baseUrl.split('#')[1];
    if (hashPart || hashPart === '') {
      var hasQuestionMark = hashPart.split('?')[1];
      if (hasQuestionMark) {
        prefix = '&';
      } else {
        prefix = '?';
      }
    } else {
      prefix = '#?';
    }
    return baseUrl + prefix + 'pro-gallery-item=' + photoId;
  };
  _proto.removeItemHashParam = function removeItemHashParam(baseUrl) {
    var itemPart = baseUrl.indexOf('pro-gallery-item=');
    // remove anything after the hash
    var newUrl = baseUrl.substr(0, itemPart > 0 ? itemPart - 1 : baseUrl.length);
    newUrl += newUrl.indexOf('#') > 0 ? '' : '#';
    return newUrl;
  };
  _proto.hexToRgba = function hexToRgba(hex, opacity) {
    hex = hex.replace('#', '');
    var r = parseInt(hex.substring(0, 2), 16);
    var g = parseInt(hex.substring(2, 4), 16);
    var b = parseInt(hex.substring(4, 6), 16);
    return "rgba(" + r + ", " + g + ", " + b + ", " + opacity + ")";
  };
  _proto.setStateAndLog = function setStateAndLog(that, caller, state, callback) {
    var _this2 = this;
    if (this.isVerbose()) {
      console.log("State Change Called (" + caller + ")", state);
      var oldState = _.clone(that.state);
      that.setState(state, function () {
        var newState = _.clone(that.state);
        var change = _this2.printableObjectsDiff(oldState, newState, 'state');
        if (_.keys(change).length > 0) {
          console.log("State Change Completed (" + caller + ")", change);
        }
        if (_.isFunction(callback)) {
          callback.bind(that)();
        }
      });
    } else {
      that.setState(state, function () {
        if (_.isFunction(callback)) {
          callback.bind(that)();
        }
      });
    }
  };
  _proto.printableObjectsDiff = function printableObjectsDiff(obj1, obj2, prefix) {
    if (prefix === void 0) {
      prefix = '';
    }
    var toString = function toString(v) {
      if (v === '') {
        v = "''";
      } else if (_.isUndefined(v)) {
        v = 'undefined';
      }
      return _.toString(v);
    };
    var _getInnerDiff = function getInnerDiff(obj1, obj2, prefix) {
      var innerDiff = _.reduce(obj1, function (res, v, k) {
        if (!_.isEqual(v, obj2[k])) {
          if (_.isArray(obj2[k])) {
            if (v.length !== obj2[k].length) {
              res[k + '.length'] = '[' + v.length + '] => [' + obj2[k].length + ']';
            }
            res = _.merge(res, _getInnerDiff(v, obj2[k], (prefix ? prefix + '.' : '') + k));
          } else if (_.isObject(obj2[k])) {
            res = _.merge(res, _getInnerDiff(v, obj2[k], (prefix ? prefix + '.' : '') + k));
          } else {
            res[(prefix ? prefix + '.' : '') + k] = toString(v) + ' => ' + toString(obj2[k]);
          }
        }
        return res;
      }, {});
      return innerDiff;
    };
    return _getInnerDiff(obj1, obj2, prefix);
  };
  _proto.getViewportScaleRatio = function getViewportScaleRatio() {
    // 320 is a hack for wix - they have fixed viewport of 320 pixels regardlessof phone type
    if (this.isMobile() && !this.isMobileViewer() && this.isSite()) {
      return 320 / this.getScreenWidth();
    } else {
      return 1;
    }
  };
  _proto.debounceWithContext = function debounceWithContext(context, debouncedFunction, delay) {
    if (delay === void 0) {
      delay = 300;
    }
    return _.bind(_.debounce(debouncedFunction, delay), context);
  };
  _proto.openModalImp = function openModalImp(url, width, height, onClose) {
    if (width === void 0) {
      width = '100%';
    }
    if (height === void 0) {
      height = '100%';
    }
    if (onClose === void 0) {
      onClose = _.noop;
    }
    return new Promise(function (resolve, reject) {
      _photographyClientLib.Wix.Settings.openModal(url, width, height, undefined, function () {
        onClose();
        resolve();
      }, true, {
        overlay: 'rgba(0,0,0,0)',
        background: 'rgba(0,0,0,0)',
        margin: false
      });
    });
  };
  _proto.openManagePhotos = function openManagePhotos() {
    return this.openModalImp(this.getManageMediaUrl());
  };
  _proto.openExpandSettings = function openExpandSettings(params) {
    this.openModalImp(this.getExpandSettingsUrl(params));
  };
  _proto.openSettingsWatermarkDisableDialog = function openSettingsWatermarkDisableDialog(callback) {
    _photographyClientLib.Wix.Settings.openModal(this.getSettingsWatermarkDisableUrl(), 612, 281, undefined, callback, true);
  };
  _proto.openSettingsAddonsUrl = function openSettingsAddonsUrl(params, callback) {
    _photographyClientLib.Wix.Settings.openModal(this.getSettingsAddonsUrl(params), 736, 281, undefined, callback, true);
  };
  _proto.findFontsHrefs = function findFontsHrefs() {
    try {
      var isFontHref = function isFontHref(x) {
        return x.toLowerCase().includes('font');
      };
      var styleSheets = top.document.styleSheets;
      return Object.keys(styleSheets).map(function (s) {
        return styleSheets[s].href;
      }).filter(function (href) {
        return href !== null;
      }).filter(isFontHref);
    } catch (e) {
      // console.warn('could not find fonts hrefs', e);
      return [];
    }
  };
  _proto.getSupportLink = function getSupportLink(progalleryLinks, storeLinks) {
    var editorArticleId = this.isStoreGallery() ? storeLinks ? storeLinks[0] : progalleryLinks[0] : progalleryLinks[0];
    var onBoardingArticleId = this.isStoreGallery() ? storeLinks ? storeLinks[1] : progalleryLinks[1] : progalleryLinks[1];
    var articleUrl = '';
    var isOnboarding = this.isOnBoarding() || !editorArticleId;
    if (editorArticleId || onBoardingArticleId) {
      var widgetCode = '';
      var articleId = '';
      var subDomain = 'support';
      var isOnBoardingReallyExists = isOnboarding && onBoardingArticleId;
      var hasOnBoardingOnly = !editorArticleId && onBoardingArticleId;
      if (isOnBoardingReallyExists || hasOnBoardingOnly) {
        widgetCode = this.CONST_ADI_SUPPORT_WIDGET_CODE;
        articleId = onBoardingArticleId;
      } else if (editorArticleId) {
        widgetCode = this.CONST_EDITOR_WIDGET_CODE;
        articleId = editorArticleId;
      }
      if (_.isUndefined(_photographyClientLib.window.locale)) {
        _photographyClientLib.window.locale = 'en';
      }
      var locale = _photographyClientLib.window.locale;
      var path = "/" + locale + "/widget/" + widgetCode + "/article/" + articleId;
      var url = new _urijs["default"]('https://wix.com/').path(path).subdomain(subDomain);
      articleUrl = url.toString();
    }
    return articleUrl;
  };
  _proto.mergeDeep = function mergeDeep() {
    var _mergeDeep2 = function _mergeDeep(dstObj, srcObj) {
      var mergeId;

      // const clonedDstVal = _.cloneDeep(dstObj);
      var res = _.mergeWith(dstObj, srcObj, function (dstVal, srcVal) {
        if (_.isObject(dstVal) && !_.isFunction(dstVal)) {
          // isObject return true for functions too
          return _mergeDeep2(dstVal, srcVal);
        } else {
          return srcVal;
        }
      });
      return res;
    };
    var merged = {};
    for (var i = 0; i < arguments.length; i++) {
      if (arguments[i]) {
        merged = _mergeDeep2(merged, arguments[i]);
      }
    }
    return merged;
  };
  _proto.getImageUrl = function getImageUrl(fileName) {
    return (_photographyClientLib.window.staticsUrl || '') + fileName;
  };
  _proto.markWidgetInSite = function markWidgetInSite(widgetId) {
    var instanceId = _photographyClientLib.window.instanceId;
    this.getLocalStorage()[instanceId + '|has-widget|' + widgetId] = true;
  };
  _proto.isWidgetInSite = function isWidgetInSite(widgetId) {
    var instanceId = _photographyClientLib.window.instanceId;
    return !_.isUndefined(this.getLocalStorage()[instanceId + '|has-widget|' + widgetId]);
  };
  _proto.getMobileEnabledClick = function getMobileEnabledClick(action) {
    // todo: bring back this line before pushing to master
    return this.isMobile() ? {
      onTouchEnd: action
    } : {
      onClick: action
    };
    // return {onClick: action};
  };
  _proto.uploadImageFromUrl = function uploadImageFromUrl(imageUrl) {
    var imageUrlTemplateBase64 = _photographyClientLib.window.btoa(imageUrl);
    var updloadMediaUrlTemplate = location.protocol + "//files.wix.com/files/upload/external?media_type=picture&ns=campaign&name=_.jpg&url=" + encodeURIComponent(imageUrl);
    return this.getUploadMediaRequest(updloadMediaUrlTemplate, 10000);
  };
  _proto.getUploadMediaRequest = function getUploadMediaRequest(uploadMediaUrl, timeout) {
    return httpClient.request({
      url: uploadMediaUrl,
      method: 'GET',
      timeout: timeout,
      withCredentials: true,
      xsrfCookieName: null
    }).then(function (_ref2) {
      var data = _ref2.data;
      return data;
    });
  };
  _proto.isInExpandSettings = function isInExpandSettings() {
    return this.parseGetParam('expandsettingsmode') === '1';
  };
  _proto.isStoreDemoImages = function isStoreDemoImages() {
    var _this3 = this;
    // NOTE: the next few lines are commented because otherwise cannot check debugApp=ph_local/ph_debug
    // if (this.isDev()) { //development mode cannot upload images so is is default false
    //   return Promise.resolve(false);
    // }
    if (this.isInExpandSettings()) {
      // expand settings uses default images
      return Promise.resolve(true);
    }
    return this.gallerySettings.getAppSettings('isStoreDemoImages').then(function (isDemo) {
      if (isDemo === undefined) {
        throw 'not in gallerySettings, fallback to dataPublic';
      }
      return isDemo;
    })["catch"](function (e) {
      return _this3.data.get('isStoreDemoImages').then(function () {
        return false;
      })["catch"](function (e) {
        if (_this3.isDev()) {
          console.log('error fetching store default images', e);
        }
        return !!(e && e.error && e.error.message && e.error.message.indexOf('not found in APP scope') > 0);
      });
    });
  };
  _proto.getProviderFromGalleryInfo = function getProviderFromGalleryInfo(galleryInfo) {
    if (galleryInfo && galleryInfo.connectedProviders) {
      return Object.keys(galleryInfo.connectedProviders)[0];
    }
    return null;
  };
  _proto.dataPublicKey = function dataPublicKey(key) {
    try {
      var compId = _photographyClientLib.Wix.Utils.getOrigCompId() || _photographyClientLib.Wix.Utils.getCompId();
      return key + '-' + compId;
    } catch (e) {
      // console.error('Cannot get compId', e);
      return key + '-no-comp-id';
    }
  };
  _proto.openMediaDialogAndApplyWatermark = function openMediaDialogAndApplyWatermark(callback) {
    _photographyClientLib.Wix.Dashboard.openMediaDialog(_photographyClientLib.Wix.Settings.MediaType.IMAGE_PRO, true, function (result) {
      var galleryId = _photographyClientLib.window.galleryId;
      var instance = _photographyClientLib.window.instance;
      _photographyClientLib.watermarkApi.applyWatermarkOnMediaDialogResult(result, galleryId, instance).then(function (watermarkData) {
        callback(result);
      });
    });
  };
  _proto.colorStringToObject = function colorStringToObject(colorString) {
    // https://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb
    try {
      var returnValue = null;
      if (typeof colorString === 'string') {
        if (colorString.trim().indexOf('rgb') === 0) {
          // rgb(1,2,3) | rgba(4,5,6,0.7)
          var values = colorString.match(/\d+/g);
          if (values && Array.isArray(values) && values.length >= 3) {
            returnValue = {
              r: values[0],
              g: values[1],
              b: values[2]
            };
          }
        } else {
          // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
          var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
          colorString = colorString.replace(shorthandRegex, function (m, r, g, b) {
            return r + r + g + g + b + b;
          });
          var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(colorString);
          returnValue = result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
          } : null;
        }
      }
      return returnValue;
    } catch (error) {
      console.error('Error converting color string to object', error);
    }
  };
  _proto.getExperimentValue = function getExperimentValue(experimentName) {
    return _.get(_photographyClientLib.window, ['petri', "specs.pro-gallery." + experimentName]);
  };
  _proto.getDateCreatedTicksFromStr = function getDateCreatedTicksFromStr(dateCreatedStr) {
    var dateCreatedTicks = null;
    var isDateCreatedValid = isNaN(Date.parse(dateCreatedStr)) === false;
    if (isDateCreatedValid) {
      return Date.parse(dateCreatedStr);
    }
    return -8640000000000000;
  };
  _proto.getQueryParamByName = function getQueryParamByName(name, url) {
    if (url === void 0) {
      url = _photographyClientLib.window.location.href;
    }
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) {
      return null;
    }
    if (!results[2]) {
      return '';
    }
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  };
  _proto.getBaseUrl = function getBaseUrl() {
    if (_photographyClientLib.window.location.origin.includes('manage.editorx')) {
      return '//manage.editorx.com';
    }
    return '//manage.wix.com';
  };
  return Utils;
}(_photographyClientLib.RenderUtils);
var utils = exports.utils = new Utils();